

export enum _size { L = "L-56", M = "M-44", S = "S-32", XS = "XS-24" }
export enum _style {
    primary = "primary",
    secondary = "secondary",
    secondary2 = "secondary-origin",
    outline = "outline",
    flat = "flat",
    clear = "clear",
    clear2 = "clear-origin",
    link = "link",
    linkDefault = "default"
}

export enum _nightMode {
    off = "day",
    on = "night"
}

export enum _clear {
    off = "off",
    on = "on"
}

export enum _typeBtn {
    default = "default",
    dropdown = "dropdown",
    defaultIcon = "default-icon",
    icon = "icon",
    iconCircle = "circly",
    split = "split",
    loader = "loader"
}

export enum _stateInput {
    normal = "normal",
    active = "active",
    readonly = ""
}

export enum _typeInput {
    text = "text",
    email = "email",
    phone = "phone",
    number = "number",
    counter = "counter",
    date = "date",
    message = "msg"
}

export enum _sizeText {
    xlb = "xlbold",
    xl = "xl",
    lbold = "lbold",
    l = "l",
    mbold = "mbold",
    m = "m",
    sbold = "sbold",
    s = "s",
    xs = "xs",
    xsbold = "xsbold",
    hmp = "hm-p",
    hmpmed = "hm-p-16-med",
    hmp2 = "hm-p2",
    hmp3 = "hm-p3"
}

export enum _aligeText {
    left = "left",
    right = "right",
    center = "center"
}

export enum _colorText {
    default = "default",
    black = "black",
    positive = "positive",
    negative = "negative",
    neutral = "neutral"
}

export enum _sizeHeading {
    h1 = "heading1",
    h2 = "heading2",
    h2_2 = "heading2_2",
    h3 = "heading3",
    h4 = "heading4",
    h5 = "heading5",
    h6 = "heading6"
}

export enum _status {
    success = "sucess",
    error = "error",
    info = "info",
    warning = "warning",
    neutral = "neutral"
}

export enum _typePreview {
    main = "main"
}

export enum _typeLogo {
    default = "default",
    white = "white",
    green = "green"
}

export enum _typeLabel {
    primary = "primary",
    secondary = "secondary",
    outline = "outline",
    flat = "flat",
    input = "input",
    neutral = "neutral"
}

const version = 34
const api = "/"
const url_telegram = "https://t.me/hm_vvlab_bot/"
const url_whatsapp = "https://api.whatsapp.com/send/?phone=79853445619&text=%D0%97%D0%B4%D1%80%D0%B0%D0%B2%D1%81%D1%82%D0%B2%D1%83%D0%B9%D1%82%D0%B5&app_absent=0`"

export {
    api, url_telegram,
    url_whatsapp,

    version
}

